import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Shows } from "@/components/site/Shows";
import { Members } from "@/components/site/Members";
import { Founders } from "@/components/site/Founders";
import { Hosts } from "@/components/site/Hosts";
import { Gallery } from "@/components/site/Gallery";
import { VipPass } from "@/components/site/VipPass";
import { MerchBooking } from "@/components/site/MerchBooking";
import { Newsletter, Footer } from "@/components/site/Closing";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { InstallPrompt } from "@/components/site/InstallPrompt";

export default function Home() {
  return (
    <div className="grain relative" data-testid="home-page">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Shows />
        <Founders />
        <Members />
        <Hosts />
        <Gallery />
        <Marquee inverted />
        <VipPass />
        <MerchBooking />
        <Newsletter />
      </main>
      <Footer />
      <InstallPrompt />
    </div>
  );
}
